/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import {
  assignBookQr,
  getBookQrDetails,
  sendPortalLinks,
} from "../../utils/scripts";
import { openMobileAppOrStore } from "../../utils/openMobileApp";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import BookExpirationInfo from "./components/BookExpirationInfo";
import { AppContext } from "../../providers/ContextProviders";
import PopUp from "../../components/PopUp";
import PrimaryBtn from "../../components/buttons/PrimaryBtn";
import AlreadyAssignedModal from "./components/AlreadyAssignedModal";
import SetBooks from "./components/SetBooks";
import { getCoverSrc } from "../../utils/s3";

const BookQrCodeDetails = () => {
  const { token } = useContext(AppContext);

  const [searchParams] = useSearchParams();
  const qrId = searchParams.get("qrId");

  const [responseData, setResponseData] = useState();
  const [isSet, setIsSet] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCover, setSelectedCover] = useState();
  const [seeMore, setSeeMore] = useState(false);
  const [modals, setModals] = useState({});
  const [assignedUser, setAssignedUser] = useState({});
  const retrieveQrDetails = async () => {
    setLoading(true);
    const { response, error } = await getBookQrDetails(qrId);
    setLoading(false);
    if (response?.status === "success") {
      setResponseData(response.data.details);
      setIsSet(response.data.isSet);
    } else {
      // toast(response?.message??'Something went wrong')
      setModals((prev) => ({ ...prev, invalidQrId: true }));
    }
    if (error) {
      toast(error?.message);
    }
  };

  const assignBookHandler = async () => {
    setLoading(true);
    const { response, error } = await assignBookQr(qrId);
    setLoading(false);
    console.log(response);
    if (response?.status === "success") {
      setModals((prev) => ({ ...prev, assignSuccess: true }));
    } else {
      // toast(response?.message??'Something went wrong')
      if (response.errorCode == "406") {
        setAssignedUser(response.assignedUser);
        setModals((prev) => ({
          ...prev,
          alreadyAssigned: true,
        }));
      } else {
        toast(response?.message ?? "Something went wrong");
      }
    }
    if (error) {
      toast(error?.message);
    }
  };

  const emailSendHandler = async () => {
   try {
    sendPortalLinks();
    setModals((prev) => ({ ...prev, assignSuccess: false }));
    toast("Email send");
   } catch (error) {
   }
  };

  useEffect(() => {
    if (token && qrId) {
      retrieveQrDetails();
    }
  }, []);
  const defaultCoverKey = responseData
    ? isSet
      ? responseData.cover
      : responseData.imageCoverFront
    : null;
  const mainCoverKey = selectedCover ?? defaultCoverKey;
  const mainCoverSrc =
    responseData && mainCoverKey
      ? getCoverSrc(responseData, mainCoverKey, isSet)
      : "";

  return (
    <>
      {loading ? (
        <Loader show={loading} />
      ) : (
        responseData && (
          <div className="p-5 w-full flex justify-center flex-col md:flex-row">
            <div className="hidden  md:flex  flex-col md:flex-row">
              <div className="md:w-1/3 w-full flex items-center flex-col">
                <div>
                  <img
                    className="object-cover"
                    src={mainCoverSrc}
                    alt="bookDetails front cover"
                  />
                  <div className="flex  flex-col lg:flex-row ml-3 lg:ml-0 lg:mt-4">
                    <div
                      className="overflow-hidden lg:ml-1 lg:mr-4 w-[58px] cursor-pointer"
                      onClick={() =>
                        setSelectedCover(
                          responseData?.[isSet ? "cover" : "imageCoverFront"]
                        )
                      }
                    >
                      <img
                        className="h-full object-cover"
                        src={getCoverSrc(
                          responseData,
                          isSet ? responseData.cover : responseData.imageCoverFront,
                          isSet
                        )}
                        alt="front cover"
                      />
                    </div>
                    {responseData?.imageCoverBack && (
                      <div
                        className="overflow-hidden lg:mr-4 w-[58px] cursor-pointer"
                        onClick={() =>
                          setSelectedCover(responseData?.imageCoverBack)
                        }
                      >
                        <img
                          className="h-full object-cover "
                          src={getCoverSrc(
                            responseData,
                            responseData.imageCoverBack,
                            isSet
                          )}
                          alt="back cover"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className=" w-full md:w-3/4 ml-2 mt-5 lg:mt-0 flex flex-col mx-2">
                <h1 className="flex items-center text-mobile-h1  lg:text-h1 text-heading text-center md:text-left font-bold lg:font-semibold">
                  {responseData?.title}
                </h1>
                {(isSet && responseData.description) ||
                  (!(
                    responseData?.shortDescription == null ||
                    responseData?.longDescription == null
                  ) && (
                    <>
                      <p className="text-tertiary-dark capitalize lg:uppercase tracking-wide font-bold lg:font-semibold text-h5 mt-4">
                        description
                      </p>
                      <p className="text-secondary-dark text-p1 my-2 lg:my-1 lg:text-h5 tracking-[0.01em] leading-6 text-left">
                        {responseData?.shortDescription ||
                          responseData?.description}
                        {seeMore && responseData.longDescription}
                        {responseData.longDescription && (
                          <span
                            onClick={() => setSeeMore((prev) => !prev)}
                            className=" ml-2 cursor-pointer text-tertiary-dark underline"
                          >
                            {!seeMore ? "Read more" : "Read less"}
                          </span>
                        )}
                      </p>
                    </>
                  ))}

                {isSet && <SetBooks set={responseData} />}

                <div className="flex-1" />
                <PrimaryBtn
                  containerClassName={"xl:w-full"}
                  onClick={assignBookHandler}
                >
                  <p>Assign</p>
                </PrimaryBtn>
              </div>
            </div>
            <div className="md:hidden">
              <div
                className={`   p-5 flex flex-col items-center justify-center rounded-lg`}
                style={{ backgroundColor: responseData.backgroundColor }}
              >
                <img
                  className="w-3/5 object-cover"
                  src={mainCoverSrc}
                  alt="bookDetails front cover"
                />
              </div>
              <div className="">
                <p className="text-[18px] font-medium mt-3 text-center ">
                  {responseData.title}
                </p>
                <p className="text-center text-mobile-p1 text-secondary-dark">
                  {responseData.Bauthors.map((a) => a.bookAuthorName).join(
                    ", "
                  )}
                </p>
              </div>
              <hr className=" my-5 " style={{ color: "gray" }} />
              <div>
                <p className="text-thumb  -mb-2">DESCRIPTION</p>
                <p className="text-secondary-dark text-p1 my-2 lg:my-1 lg:text-h5 tracking-[0.01em] leading-6 text-left">
                  {responseData?.shortDescription || responseData?.description}
                  {seeMore && responseData.longDescription}
                  {responseData.longDescription && (
                    <span
                      onClick={() => setSeeMore((prev) => !prev)}
                      className="cursor-pointer text-tertiary-dark underline"
                    >
                      {" "}
                      {!seeMore ? "Read more" : "Read less"}
                    </span>
                  )}
                </p>
                {isSet && <SetBooks set={responseData} />}
              </div>
            </div>
            <div className=" w-full md:w-1/4 md:min-w-[300px] ">
              <BookExpirationInfo responseData={responseData} isSet={isSet} />
            </div>
            <PrimaryBtn
              containerClassName={" mt-3 xl:hidden"}
              onClick={assignBookHandler}
            >
              <p>Assign</p>
            </PrimaryBtn>
          </div>
        )
      )}
      <PopUp
        height={30}
        show={!qrId}
        title="Qr Code Not found"
        body="This Qr code is missing. Please verify and scan again."
        disableClose
        onClick={() => {}}
        btnTitle="Okay"
      />
      <PopUp
        height={30}
        show={modals.invalidQrId ?? false}
        title="Invalid Qr Code."
        body="This Qr code is invalid. Please use a valid one to continue."
        disableClose
        onClick={() => {}}
        btnTitle="Okay"
      />
      <PopUp
        height={30}
        show={modals.assignSuccess ?? false}
        title="Success"
        body={
          <div>
            This book is assigned successfully. Continue Reading the book on your desktop via the ePrakashak Reader.
          </div>
        }
        disableClose
        // onClick={() => setModals((prev) => ({ ...prev, assignSuccess: false }))}
        onClick={() => openMobileAppOrStore(qrId)}
        btnTitle="I already have the Reader"
        secondaryButton={{
          onClick: () => emailSendHandler(),
          title: "Receive Download Link via Email",
        }}
        // tertiaryButton={{
        //   title: "Open in ePrakashak app",
        //   onClick: () => openMobileAppOrStore(qrId),
        // }}
      />
      <AlreadyAssignedModal
        height={50}
        show={modals.alreadyAssigned ? true : false}
        assignedUser={assignedUser ?? {}}
        onClick={() => {
          setModals((prev) => ({ ...prev, alreadyAssigned: false }));
        }}
        onClose={() => {
          setModals((prev) => ({ ...prev, alreadyAssigned: false }));
        }}
        btnTitle="Okay"
      />
    </>
  );
};

export default BookQrCodeDetails;
